import React, { useState } from "react";
import classnames from "classnames";
import { RadioGroup } from "@my-scoot/component-library-legacy";
import {
  BOOKING_QUESTION_SAVE_CHANGES_OPTIONS,
  BOOKING_QUESTION_SAVE_CHANGES_TYPE,
  MODAL_CONTENT,
} from "./constants/SaveQuestionChanges.constants";
import { BannerNoteChip } from "../common/BannerNoteChip/BannerNoteChip";

export const SaveQuestionChanges = ({
  selected,
  onSelect,
}: {
  selected: number;
  onSelect: (value: number) => void;
}) => {
  return (
    <div>
      <BannerNoteChip text={MODAL_CONTENT.NOTE} />
      <div className="tw-px-4 tw-pt-3 tw-pb-5">
        <p className="tw-text-[15px] tw-text-[#272522] tw-font-semibold tw-leading-tight">
          {MODAL_CONTENT.HEADER}
        </p>

        <div className="tw-mt-4">
          <RadioGroup
            options={BOOKING_QUESTION_SAVE_CHANGES_OPTIONS}
            selected={BOOKING_QUESTION_SAVE_CHANGES_OPTIONS.find(
              ({ value }) => value === selected
            )}
            onChange={({ value }: { value: number }) => onSelect(value)}
            formControlLabelClassName={classnames(
              "!tw-whitespace-nowrap",
              "tw-text-sm md:tw-text-base"
            )}
          />
        </div>
      </div>
    </div>
  );
};
